import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type OneClickLaunchModalType =
  | "None"
  | "RemoveAsins"
  | "PublishLaunchDates"
  | "PublishLaunchAttributesRemoveWeblab"
  | "PastAnnounceDateWarning";

export type PendingActionType =
  | "PublishLaunchDates"
  | "PublishLaunchAttributesRemoveWeblab"
  | null;

export interface OneClickLaunchModalState {
  message: string;
  isOpen: boolean;
  title: string;
  type: OneClickLaunchModalType;
  pendingActionType: PendingActionType;
}

export const oneClickLaunchModalInitialState: OneClickLaunchModalState = {
  message: "",
  isOpen: false,
  title: "",
  type: "None",
  pendingActionType: null,
};

const oneClickLaunchModalState = createSlice({
  name: "oneClickLaunchModalState",
  initialState: oneClickLaunchModalInitialState,
  reducers: {
    setOneClickLaunchModalState(
      state: OneClickLaunchModalState,
      action: PayloadAction<OneClickLaunchModalState>
    ) {
      if (action.payload.isOpen) {
        state.isOpen = true;
        state.title = action.payload.title;
      } else {
        state = oneClickLaunchModalInitialState;
      }
    },
    showOclRemoveModal(state: OneClickLaunchModalState) {
      state.isOpen = true;
      state.message =
        'To remove the following ASINs from your Launch View, press "Remove". If you\'d like to remove them and reset their PSED and PSLD dates to 12/31/2037 GMT, press "Reset and Remove"';
      state.title = "Removing Launch ASIN(s)";
      state.type = "RemoveAsins";
    },
    showOclPublishLaunchDatesModal(state: OneClickLaunchModalState) {
      state.isOpen = true;
      state.message =
        "Do you want to publish today's date as the PSED and PSLD dates for these ASINs?";
      state.title = "Publish Launch Dates for ASIN(s)";
      state.type = "PublishLaunchDates";
    },
    showOclPublishLaunchAttributesRemoveWeblabModal(
      state: OneClickLaunchModalState
    ) {
      state.isOpen = true;
      state.message =
        "Do you want to publish launch attributes (third_party_site_excluded and index_suppressed) and remove the weblab gating for these ASINs?";
      state.title = "Publish Launch Attributes for ASIN(s)";
      state.type = "PublishLaunchAttributesRemoveWeblab";
    },
    showOclPastAnnounceDateWarningModal(
      state: OneClickLaunchModalState,
      action: PayloadAction<PendingActionType>
    ) {
      state.isOpen = true;
      state.message =
        "One or more ASINs have an Announce Date in the past. Please review your filters and update as needed. In most cases, you will not select 'Publish Launch Dates' for previously launched ASINs when making updates.";
      state.title = "Past Announce Date Warning";
      state.type = "PastAnnounceDateWarning";
      state.pendingActionType = action.payload;
    },
    clearOclModal(state: OneClickLaunchModalState) {
      state.isOpen = false;
      state.message = "";
      state.title = "";
      state.type = "None";
      state.pendingActionType = null;
    },
  },
});

export const {
  showOclRemoveModal,
  clearOclModal,
  showOclPublishLaunchDatesModal,
  showOclPublishLaunchAttributesRemoveWeblabModal,
  showOclPastAnnounceDateWarningModal,
} = oneClickLaunchModalState.actions;

export default oneClickLaunchModalState.reducer;
